/* eslint-disable no-script-url */
import React, { useEffect, useState } from 'react';
import { formatHashValue } from 'utils';

import ConnectWalletButton from 'pages/components/ConnectWalletButton';
import AccountDetail from 'components/AccountDetail';
import styled from 'styled-components';
import makeBlockie from 'ethereum-blockies-base64';
import { TYPE } from 'theme';
import { observer } from 'mobx-react';

import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

import { useAccountModal, useChainModal } from '@rainbow-me/rainbowkit';
import { GradientBorderBox } from 'components/styled/Box';
import { SupportChainIDs } from 'constant';
import { useAccount } from 'wagmi';

const AccountButton = styled(GradientBorderBox)`
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 14px !important;
    padding: 0 20px !important;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 50px;
    border-radius: 25px;
    overflow: hidden;
    gap: 10px;
    ${({ theme }) => theme.mediaWidth.upToSmall`
        height: 40px;
    `};
`;

const Address = styled.div`
    background: transparent;
    height: 100%;
    display: flex !important;
    align-items: center;
    color: #fff;
    gap: 12px;
    border-radius: 15px;

    img {
        width: 24px;
        height: 24px;
        border-radius: 12px;
    }
`;

const PointWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 5px;
    height: 38px;
    border-radius: 19px;
    padding: 3px;
    background-color: #fff;
    padding-right: 10px;
    img {
        width: 32px;
        height: 32px;
    }
`;

const StyledKeyboardArrowDownIcon = styled(KeyboardArrowDownIcon)`
    color: #fff;
`;

const ErrorIcon = styled(ErrorOutlineIcon)`
    color: #ff4d4f;
    font-size: 20px !important;
    margin-left: 4px;
`;

interface Props {
    connected: boolean;
    walletAddress: string;
    className?: string;
}

function ConnectButton({ connected, walletAddress, className }: Props) {
    const { openAccountModal } = useAccountModal();
    const { openChainModal } = useChainModal();
    const { chainId } = useAccount();
    const [isOpenAccountDetail, setIsOpenAccountDetail] = useState(false);
    const isWrongNetwork = connected && chainId !== undefined && !SupportChainIDs.includes(chainId);

    useEffect(() => {
        if (isWrongNetwork && openChainModal) {
            openChainModal();
        }
    }, [isWrongNetwork, openChainModal]);

    return (
        <>
            {!connected || !walletAddress ? (
                <ConnectWalletButton className={className} />
            ) : isWrongNetwork ? (
                <AccountButton onClick={openChainModal}>
                    <TYPE.main
                        color={'#fff'}
                        fontSize={12}
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                        }}
                    >
                        Wrong network
                    </TYPE.main>
                </AccountButton>
            ) : (
                <AccountButton
                    onClick={() => {
                        setIsOpenAccountDetail(true);
                    }}
                >
                    <Address>
                        <img src={makeBlockie(walletAddress)} alt="" />

                        <TYPE.main
                            color={'#fff'}
                            fontSize={12}
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                            }}
                        >
                            {formatHashValue(walletAddress)}
                        </TYPE.main>
                    </Address>
                </AccountButton>
            )}
            <AccountDetail
                isOpen={isOpenAccountDetail}
                onClose={() => {
                    setIsOpenAccountDetail(false);
                }}
            />
        </>
    );
}

export default observer(ConnectButton);
